import { render, staticRenderFns } from "./FooterShop.vue?vue&type=template&id=cab4f4ee&scoped=true&"
import script from "./FooterShop.vue?vue&type=script&lang=js&"
export * from "./FooterShop.vue?vue&type=script&lang=js&"
import style0 from "./FooterShop.vue?vue&type=style&index=0&id=cab4f4ee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cab4f4ee",
  null
  
)

export default component.exports